<body>
  <header>
    <h1 [translate]="titolo"></h1>
    <meta name="description" content="Prodotti e integratori 100% naturali">
  </header>
</body>
